export default {
  employees: "Kassirlar",
  noCreatedYet: "Hali kassirlar yaratilmagan",
  downloadAppRCKassa: "RC KASSA ilovasini yuklab olish",
  downloadRCKassa: "RC KASSA yuklab olish",
  addingEmployee: "Kassir qo‘shish",
  toCreateEmployeeNeedPoint:
    "Kassir yaratish uchun kamida bitta savdo nuqtasi kerak",
  secondName: "Kassir familiyasi",
  firstName: "Kassir ismi",
  toTradingPoints: "Savdo nuqtalariga",
  uWantToDeleteEmployee: "Siz kassirni o‘chirmoqchimisiz?",
  personName: "Familiya va Ism",
  blockAccess: "Kirishni bloklash",
  openAccess: "Kirishni ochish",

  employeeScore: "Kassirlar ballari",
  points: "ball",
  debiting: "Chekish",
  accrual: "Hisobga qo‘shish",

  enterPointsAmount:
    "Mijozlarga ballarni hisoblash operatsiyalarini amalga oshirgan kassirlar oladigan ballar sonini kiriting",
  forRealClientsOperations: "Mavjud mijozlar operatsiyalari uchun",
  forNewClientsOperation: "Yangi mijozlar operatsiyalari uchun",
  toSetPointsNeedBuyTariff:
    "Kassirlarga ball qo‘yish uchun «Promo» yoki «Pro+» tarifini sotib olish kerak",
};
